export interface testimonialsType {
    id: number,
    image: string,
    name: string,
    rating: string,
    comment: string
}

export const testimonials:testimonialsType[] = [
    {
        id: 1,
        image: "okafor",
        name: "Okafor Peter",
        rating: "",
        comment: "This medical emergency web app is an absolute lifesaver! It's incredibly user-friendly and provides step-by-step guidance on what to do in different emergency situations."
    },
    {
        id: 2,
        image: "victoria",
        name: "Okoro Victoria",
        rating: "",
        comment: "I applaud the creators of this medical emergency app for their innovation and dedication to saving lives. The app accurately gave me location to a hospital during an emergency,"
    },
    {
        id: 3,
        image: "ndubisi",
        name: "Mrs Hapiness Ndubisi",
        rating: "",
        comment: "As a parent, I feel a tremendous sense of relief knowing that this medical emergency app is just a tap away. It's comforting to know that if anything happens to my child, I can quickly access emergency services and provide them with crucial information."
    },
    {
        id: 4,
        image: "chinenye",
        name: "Madu Chinenye",
        rating: "",
        comment: "This medical emergency app is an absolute necessity in today's fast-paced world. It's not just for individuals with existing health issues – it's for everyone."
    },
    {
        id: 5,
        image: "adewale",
        name: "Adewale John",
        rating: "",
        comment: "I've used it to assist a colleague who fainted at work, and the app's guidance helped us provide immediate aid until professional help arrived. Highly recommend!"
    }
]